import { delay, put, takeEvery, call, select } from 'redux-saga/effects';

import { API } from 'commons/constants/KeyFlowAPI';
import { Preferences } from 'commons/constants/KeyFlowConstants';
import { getAPI } from 'commons/framework/KeyFlowAPIRequest';
import KeyFlowResponse from 'commons/framework/KeyFlowResponse';
import PreferenceVO, { PreferenceVOProps } from 'commons/vo/PreferenceVO';

import {
  requestPreferenceByBannerFailure,
  requestPreferenceByBannerSuccess,
  requestPreferenceListFailure,
  requestPreferenceListSuccess,
  throwError,
} from 'redux/actions/actions';
import { RequestPreferenceByBannerAction, RequestPreferenceListAction } from 'redux/actions/type';
import {
  REQUEST_PREFERENCE_BY_BANNER,
  REQUEST_PREFERENCE_LIST,
  REQUEST_SCRIPT_LIST,
} from 'redux/actions/types';
import { AxiosResponse } from 'axios';

function* requestPreferenceListSaga(action: RequestPreferenceListAction) {
  try {
    const { groupNames }: { groupNames: string[] } = action.payload;
    const response: AxiosResponse = yield call(getAPI, API.PREFERENCE, { groupNames });
    const keyFlowResponse = new KeyFlowResponse(response.data);

    const resultList = keyFlowResponse.getResult();

    const video: Map<string, PreferenceVO> = new Map();
    const videoLibrary: Map<string, PreferenceVO> = new Map();

    resultList.forEach(result => {
      const key = Object.keys(result)[0];
      const values = result[key];
      switch (key) {
        case Preferences.groupNames.VIDEO:
          values.forEach((value: PreferenceVOProps) => {
            const preference = new PreferenceVO(value);
            video.set(preference.name, preference);
          });
          break;
        case Preferences.groupNames.VIDEO_LIBRARY:
          values.forEach((value: PreferenceVOProps) => {
            const preference = new PreferenceVO(value);
            videoLibrary.set(preference.name, preference);
          });
          break;
        default:
          break;
      }
    });

    yield put(requestPreferenceListSuccess({ video, videoLibrary }));
  } catch (error: any | Error) {
    yield put(throwError({ error }));
    yield put(requestPreferenceListFailure());
  }
}

function* requestPreferenceByBannerSaga(action: RequestPreferenceByBannerAction) {
  try {
    const response: AxiosResponse = yield call(getAPI, API.PREFERENCE_BY_BANNER);
    const keyFlowResponse = new KeyFlowResponse(response.data);
    const resultList: PreferenceVO[] = keyFlowResponse.getResult(PreferenceVO) as PreferenceVO[];
    const banner: Map<string, PreferenceVO> = new Map();

    resultList.forEach(preference => {
      banner.set(preference.name, preference);
    });

    yield put(requestPreferenceByBannerSuccess({ banner }));
  } catch (error: any | Error) {
    yield put(throwError({ error }));
    yield put(requestPreferenceByBannerFailure());
  }
}

export function* watchPreferenceSaga() {
  yield takeEvery(REQUEST_PREFERENCE_LIST, requestPreferenceListSaga);
  yield takeEvery(REQUEST_PREFERENCE_BY_BANNER, requestPreferenceByBannerSaga);
}
